import React from 'react';
import { compose, is } from 'ramda';
import styleFile from './AmazonPayWidget.js';
import { connect } from 'react-redux';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { List, Map } from 'immutable';
import storage from '@synergycms_core/utils/storage';
import moment from 'moment';
import AmazonPay from './AmazonPay';
import { withForm } from '@synergycms_core/components/generic/Form';

let setAmazonReferenceId = false;

const AmazonPayWidget = class AmazonPayWidget extends AmazonPay {
  static displayName = 'AmazonPayWidget';

  /** @type {string} */
  amazonPayContainerWidgetID = 'AmazonPayWidget';
  /** @type {string|boolean} */
  orderReferenceId = false;
  /** @type {boolean} */
  widgetRendered = false;
  /** @type {string|boolean} */
  validAccessToken = false;
  /** @type {number|boolean} */
  orderTotal = false;

  constructor(props) {
    super(props);
    this.checkExpiration();
  }

  onAmazonPaymentsReady = () => {
    const { amazonPayMerchantID, totalPrice, amazonPayEnabled, payFormSelected, nRetry } = this.props.config;

    new window.OffAmazonPayments.Widgets.Wallet({
      sellerId: amazonPayMerchantID,
      // Add the onOrderReferenceCreate function to
      // generate an Order Reference ID.
      onOrderReferenceCreate: (orderReference) => {

        this.widgetRendered = true;
        const amazonOrderReferenceId = orderReference.getAmazonOrderReferenceId();
        if(amazonPayEnabled && payFormSelected === this.amazonPayForm && (totalPrice !== this.orderTotal || !this.orderReferenceId)) {
          this.orderReferenceId = setAmazonReferenceId(amazonOrderReferenceId, nRetry);
          if(this.orderReferenceId) {
            this.orderTotal = totalPrice;
          }
        } else if( payFormSelected !== this.amazonPayForm) {
          this.orderReferenceId = false;
        }
      },
      design: {
        designMode: 'smartphoneCollapsible'
      },
      onPaymentSelect: (orderReference) => {
        const amazonDiv = window.document.getElementById("AmazonPayWidget").querySelector('.widget-container');
        if(amazonDiv) {
          amazonDiv.style.height = '180px';
          const amazonIframe = amazonDiv.querySelector('iframe');
          if(amazonIframe) {
            amazonIframe.style.height = '180px';
          }
        }
        this.widgetRendered = true;
        // Replace this code with the action that you want to perform
        // after the payment method is selected.
        // console.log("CONTINUE?");
        // Ideally this would enable the next action for the buyer
        // such as a "Continue" or "Place Order" button.
      },
      onError: (error) => {
        this.widgetRendered = false;
        // Your error handling code.
        // During development you can use the following
        // code to view error messages:
        // console.log(error.getErrorCode() + ': ' + error.getErrorMessage());
        // See "Handling Errors" for more information.
      }
    }).bind(this.amazonPayContainerWidgetID);
  };

  loadWidget = () => {
    const { amazonPayClientID } = this.props.config;

    const onLoadFunc = () => {
      setTimeout(() => {
        const container = document.getElementById(this.amazonPayContainerWidgetID);
        if(container) {
          container.innerHTML = '';
          if (this.amazonPayScriptTag) {
            document.head.removeChild(this.amazonPayScriptTag);
            this.amazonPayScriptTag = null;
          }
          new Promise((resolve, reject) => {
            window.onAmazonLoginReady = this.onAmazonLoginReady(amazonPayClientID);
            window.onAmazonPaymentsReady = this.onAmazonPaymentsReady;

            this.amazonPayScriptTag = this.addAmazonPayScriptTag();

            const onErrorFunc = () => {
              setTimeout(() => {
                this.amazonPayScriptTag = this.addAmazonPayScriptTag();
                this.amazonPayScriptTag.onerror = onErrorFunc;
                this.amazonPayScriptTag.onload = onLoadFunc;
              }, 1000);
            };

            const onLoadFunc = () => {
              resolve('ok');
            };

            this.amazonPayScriptTag.onerror = onErrorFunc;
            this.amazonPayScriptTag.onload = onLoadFunc;
          });

        } else {
          onLoadFunc();
        }
      }, 200);
    };
    onLoadFunc();
  };

  checkExpiration = () => {
    const timer = () => {
      setTimeout(() => {
        const amazonAccessToken = storage.getLocal('amazon_access_token');
        const amazonAccessTokenExpires = storage.getLocal('amazon_access_token_expire');
        if(amazonAccessToken && amazonAccessTokenExpires && moment().isBefore(moment(amazonAccessTokenExpires))) {
          this.validAccessToken = amazonAccessToken;
        } else {
          this.validAccessToken = false;
        }

        if((!this.validAccessToken && this.widgetRendered) || (this.validAccessToken && !this.widgetRendered)) {
          this.forceUpdate();
        }
        timer();
        /* TODO Quan funcioni el tema de URLs posar el moment exacte en que s'ha de comprovar */
      }, 5000 );
    };
    timer();
  };

  componentDidUpdate(prevProps) {

    if(this.validAccessToken) {
      this.loadWidget();
    } else {
      this.widgetRendered = false;
    }
  }

  render() {
    const { amazonPayEnabled, payFormSelected } = this.props.config;
    const { classes } = this.props.theme.styles;
    const amazonAccessToken = storage.getLocal('amazon_access_token');
    const amazonAccessTokenExpires = storage.getLocal('amazon_access_token_expire');
    if(amazonAccessToken && amazonAccessTokenExpires && moment().isBefore(moment(amazonAccessTokenExpires))) {
      this.validAccessToken = amazonAccessToken;
    } else {
      this.validAccessToken = false;
    }

    return amazonPayEnabled && this.validAccessToken && (
      <div
        id={this.amazonPayContainerWidgetID}
        className={payFormSelected === this.amazonPayForm ? classes[this.amazonPayContainerWidgetID] : classes.displayNone}
      />
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const amazonPayEnabled = hotel.getIn(['amazon_pay', 'name'], false);
  const amazonPayParams = amazonPayEnabled && hotel && hotel.getIn(['amazon_pay', 'tpv_params'], List());
  const amazonPayClientID = amazonPayParams.find(p => p.get('code') === 'client_id', Map()).get('value', '');
  const amazonPayMerchantID = amazonPayParams.find(p => p.get('code') === 'merchant_id', Map()).get('value', '');
  const showTaxes = hotel && hotel.get('show_taxes', true);
  const reservation = store.getIn(['customer', 'reservation']);

  // Ho tenim declarat a fora ja que si ho passem per prop el component s'està renderitzant a cada petit canvi, cosa que
  // provoca un efecte horrible quan refresca tot el widget d'amazon constantment
  // tampoc podem comparar les funcions ja que l'inputList realment està modificant-se a cada canvi
  setAmazonReferenceId = ownProps.setAmazonReferenceId(ownProps.form.validForm, ownProps.form.inputList);

  return {
    amazonPayEnabled: amazonPayEnabled,
    amazonPayClientID: amazonPayClientID,
    amazonPayMerchantID : amazonPayMerchantID,
    nRetry : reservation.getIn(['payment', 'n_retry'], 1),
    totalPrice: reservation.get(showTaxes ? 'total_price_tax' : 'total_price')
  };
};

export default compose(
  withForm(),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'amazonPayEnabled',
    'amazonPayMerchantID',
    'amazonPayClientID',
    'payFormSelected',
    'totalPrice',
    'nRetry'
  ]),
  withThemeJSS({ styleFile })
)(AmazonPayWidget);
